import { render, staticRenderFns } from "./TheSocialLinks.vue?vue&type=template&id=b946f6ac&scoped=true&"
import script from "./TheSocialLinks.vue?vue&type=script&lang=js&"
export * from "./TheSocialLinks.vue?vue&type=script&lang=js&"
import style0 from "./TheSocialLinks.vue?vue&type=style&index=0&id=b946f6ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b946f6ac",
  null
  
)

export default component.exports